import axios from 'axios';

let baseRequest = axios.create();
const getBaseRequest = () => baseRequest;
const setBaseRequest = (_baseRequest) => baseRequest = _baseRequest;
const createBaseRequest = axios.create;
const request = (url, { data, method = "POST" }) => {
  const _baseRequest = getBaseRequest();
  return _baseRequest({
    method,
    url,
    data
  }).then((res) => {
    return res.data;
  });
};

export { createBaseRequest, getBaseRequest, request, setBaseRequest };
